(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/assets/javascripts/commands/nav-big-constants.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/assets/javascripts/commands/nav-big-constants.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.commands = svs.statistics.big.commands || {};

  svs.statistics.big.commands.DEEP_NAVIGATION = 'deep_navigation';
  svs.statistics.big.commands.PRE_DRAW_MATCH = 'pre_draw_match';
  svs.statistics.big.commands.PRE_DRAW_LEAGUE = 'pre_draw_league';
  svs.statistics.big.commands.PRE_DRAW_TEAM = 'pre_draw_team';
})(svs);

 })(window);